module.exports = __webpack_public_path__ + "AdobeStock_285202108_monitor.svg?72f999237dab7421c0982abab1e618fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_monitor.svg
// module id = 324
// module chunks = 0